(function() {
    'use strict';

    angular
        .module('telestatApp')
        .factory('LogsViewerService', LogsViewerService);

    LogsViewerService.$inject = ['$resource'];

    function LogsViewerService ($resource) {
        var service = $resource('api/logs-viewer/:verb/:fileName', {}, {
            'list': { method: 'GET', params: {verb:'list'}, isArray: true},
            'load': { method: 'POST', params: {verb:'load'}, isArray: true},
            'loadPartial': { method: 'POST', params: {verb:'loadPartial'}, isArray: true}
        });

        return service;
    }
})();
